module.exports = __webpack_public_path__ + "static/media/santa_clara_1_big.53e5b332.png";